import { HttpInterceptorFn } from '@angular/common/http';
import { HttpRequest } from '@angular/common/http';
import { APP_CONFIG } from '../../core/constants/app.constants';

/**
 * Auth interceptor that attaches Authorization header if a token exists.
 * Adjust token retrieval logic as per your auth storage strategy.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  try {
    let token = localStorage.getItem('auth_token');
    // token = 'cGF0aGZuZHI6aHR0cHM6Ly9lbnRlcnByaXNlLnBhdGhmbmRyLmlvOjIxMDcy' // enterprise
    // token = 'cGF0aGZuZHI6aHR0cHM6Ly9uY2hpcmFnLnBhdGhmbmRyLmlvOjIyOTMy' // nchirag
    // token = 'Basic cGF0aGZuZHI6aHR0cHM6Ly9kZW1vLnBhdGhmbmRyLmlvOjcw' // demo


    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    const isSameOrigin =
      !!origin && (req.url.startsWith(origin) || req.url.startsWith('/'));
    const shouldIncludeCreds =
      isSameOrigin ||
      req.url.includes('pathfndr') ||
      req.url.includes('metripping') ||
      req.url.includes('grnconnect') ||
      req.url.includes('somewherefine.com') ||
      req.url.startsWith(APP_CONFIG.url || '');

    if (token || shouldIncludeCreds) {
      const headers: Record<string, string> = {};
      if (token) headers['Authorization'] = `Basic ${token}`;
      const authReq = req.clone({
        setHeaders: headers,
        withCredentials: true,
      });
      return next(authReq);
    }
  } catch {
    // no-op if storage is unavailable
  }

  return next(req);
};


